import React, { useState } from 'react'
import { Info, X } from 'lucide-react'

interface InfoTooltipProps {
  title: string
  imagePath: string
  position?: 'top' | 'bottom' | 'left' | 'right'
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({ 
  title, 
  imagePath, 
  position = 'bottom' 
}) => {
  const [showTooltip, setShowTooltip] = useState(false)
  const [showModal, setShowModal] = useState(false)

  const getTooltipPositionClasses = () => {
    switch (position) {
      case 'top':
        return 'bottom-full left-1/2 transform -translate-x-1/2 mb-2'
      case 'bottom':
        return 'top-full left-1/2 transform -translate-x-1/2 mt-2'
      case 'left':
        return 'right-full top-1/2 transform -translate-y-1/2 mr-2'
      case 'right':
        return 'left-full top-1/2 transform -translate-y-1/2 ml-2'
      default:
        return 'top-full left-1/2 transform -translate-x-1/2 mt-2'
    }
  }

  return (
    <>
      <div className="relative inline-block">
        <button
          type="button"
          className="text-blue-500 hover:text-blue-700 transition-colors duration-200"
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onClick={() => setShowModal(true)}
        >
          <Info className="w-4 h-4" />
        </button>

        {/* Hover Tooltip */}
        {showTooltip && (
          <div className={`absolute z-50 ${getTooltipPositionClasses()}`}>
            <div className="bg-gray-800 text-white text-xs rounded-lg py-2 px-3 whitespace-nowrap shadow-lg">
              <div className="relative">
                {title}
                <div className="text-xs text-gray-300 mt-1">Klicken für Details</div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Modal with Image */}
      {showModal && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
          onClick={() => setShowModal(false)}
        >
          <div 
            className="bg-white rounded-lg shadow-xl max-w-4xl max-h-[90vh] overflow-hidden"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex items-center justify-between p-4 border-b">
              <h3 className="text-lg font-semibold text-gray-800">{title}</h3>
              <button
                onClick={() => setShowModal(false)}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            <div className="p-4 overflow-auto">
              <img 
                src={imagePath} 
                alt={title}
                className="w-full h-auto rounded-lg shadow-sm"
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
} 